import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getProduct } from "../../services/product.service";
import { useSelector } from "react-redux";

export default function RateDiaryDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [product, setProduct] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productID = queryParams.get("id");
  const backPage = parseInt(queryParams.get("page"));
  const search = queryParams.get("search");

  const fetchProduct = async () => {
    try {
      const res = await getProduct(token, productID);
      // console.log(res?.data);

      if (res && res.status >= 200 && res.status < 300) {
        setProduct(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch product details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main product:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the product. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Product Details</h4>
                <Link to={`/products?page=${backPage}${
                search ? `&search=${search}` : ""
              }`}>
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Product */}
                  <div className="col-sm-6 mb-4">
                    <h5>Product</h5>
                    <p>{product?.product_name || "N/A"}</p>
                  </div>

                  {/* Company Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Company Name</h5>
                    <p>{product?.brand_name || "N/A"}</p>
                  </div>

                  {/* Image */}
                  <div className="col-sm-6 mb-4">
                    <h5>Image</h5>
                    {product?.image ? (
                      <img
                        src={product?.image}
                        alt="Product"
                        className="img-thumbnail w-25"
                        style={{ width: "200px" }}
                      />
                    ) : (
                      <p>No Image Available</p>
                    )}
                  </div>

                  {/* Design Number */}
                  <div className="col-sm-6 mb-4">
                    <h5>Design Number</h5>
                    <p>
                      {product?.product_design_number
                        ?.map((item) => item.design_no)
                        .join(", ") || "N/A"}
                    </p>
                  </div>

                  {/* Acronym */}
                  <div className="col-sm-6 mb-4">
                    <h5>Acronym</h5>
                    <p>{product?.brand_acronym || "N/A"}</p>
                  </div>

                  {/* Category*/}
                  <div className="col-sm-6 mb-4">
                    <h5>Category</h5>
                    <p>
                      {product?.subcategory_name || "N/A"} (
                      {product?.main_category_name || "N/A"})
                    </p>
                  </div>

                  {/* pcs_in_set*/}
                  <div className="col-sm-6 mb-4">
                    <h5>Peaces in Set</h5>
                    <p>{product?.pcs_in_set || "N/A"}</p>
                  </div>

                  {/* assorted */}
                  <div className="col-sm-6 mb-4">
                    <h5>Assorted</h5>
                    <p>{product?.assorted ? "Yes" : "No" || "N/A"}</p>
                  </div>

                   {/* Assorted Pieces in set */}
                   {product?.assorted && <div className="col-sm-6 mb-4">
                    <h5>Assorted Pieces in Set</h5>
                    <p>{product?.assorted_pcs_in_set || "N/A"}</p>
                  </div>}

                  {/* colors */}
                  <div className="col-sm-6 mb-4">
                    <h5>colors</h5>
                    <p>
                      {product?.colors?.map((item) => item.name).join(", ") ||
                        "N/A"}
                    </p>
                  </div>

                  {/*fabric */}
                  <div className="col-sm-6 mb-4">
                    <h5>Fabric</h5>
                    <p>{product?.fabric || "N/A"}</p>
                  </div>

                  {/* Stock */}
                  <div className="col-sm-6 mb-4">
                    <h5>In Stock</h5>
                    <p>
                      {product?.in_stock === true
                        ? "Yes"
                        : product?.in_stock === false
                        ? "No"
                        : "N/A"}
                    </p>
                  </div>

                  {/* Description */}
                  <div className={`${product?.assorted ? "col-md-12" : "col-md-6"} mb-4`}>
                    <h5>Description</h5>
                    <p>{product?.description || "No description provided"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
